import { Theme } from '@mui/material';
import { FC, ReactNode, useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import BottomDrawer from '../../elements/BottomDrawer/BottomDrawer';
import { selectSbom } from '../actions/sbom-libraries-actions';
import { SbomLibraryItem } from '../sbom-types';
import SbomCard from './SbomCard';

const SbomDrawer: FC<React.PropsWithChildren<SbomDrawerProps>> = ({
  className,
  sbom,
  loading,
  defaultHeight,
  onResizeStop,
}) => {
  const { libraryName, libraryVersion } = sbom || {};
  const { classes } = useStyles();

  const clearSelectedSbom = useCallback(() => {
    selectSbom(null);
  }, []);

  return (
    <BottomDrawer
      className={className}
      onClose={clearSelectedSbom}
      loading={!!loading}
      defaultHeight={defaultHeight}
      onResizeStop={onResizeStop}
      title={
        sbom && (
          <div className={classes.appName}>
            {libraryName}@{libraryVersion}
          </div>
        )
      }>
      {sbom && <SbomCard sbom={sbom} />}
    </BottomDrawer>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  buttons: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  appName: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}));
export interface SbomDrawerProps {
  sbom?: SbomLibraryItem;
  className?: string;
  extras?: ReactNode;
  loading?: boolean;
  defaultHeight?: number;
  onResizeStop?: (height: number) => void;
}

export default SbomDrawer;
